import { render, staticRenderFns } from "./RetornosDetalleModal.vue?vue&type=template&id=35f530d8"
import script from "./RetornosDetalleModal.vue?vue&type=script&lang=js"
export * from "./RetornosDetalleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports